import { render, staticRenderFns } from "./GradientButton.vue?vue&type=template&id=524fa5f0&scoped=true&"
import script from "./GradientButton.vue?vue&type=script&lang=js&"
export * from "./GradientButton.vue?vue&type=script&lang=js&"
import style0 from "./GradientButton.vue?vue&type=style&index=0&id=524fa5f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524fa5f0",
  null
  
)

export default component.exports